import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { makeStyles, ThemeProvider } from '@mui/styles';
import { StyledEngineProvider } from '@mui/styled-engine';
import CSSBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

import Themes from '../../data/themes';
import UsersService from '../../data/users-service';
import useWindowSize from '../../libraries/usewindowsize';

const useStyles = makeStyles(theme => ({
    background: {
        backgroundColor: '#031018',
    }
}));

const HEADER_SIZE = 345;

const Forgot = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [forgotSent, setForgotSent] = useState(false);
    const { height } = useWindowSize();

    const handleUpdateUser = (e) => {
        setUsername(e.target.value);
        setDisableSubmit(!e.target.value.length);
    };

    const handleSendResetEmail = () => {
        UsersService.resetPassword(username);
        setForgotSent(true);
    };

    const cancel = () => {
        navigate('/signin');
    };

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={Themes.DarkTheme}>
                <Box height="100%" className={classes.background} color="text.primary">
                    <CSSBaseline />
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Box textAlign="center" mt={30} mb={5}>
                            <img aria-label="logo" src="/images/logo-new.png" />
                        </Box>
                    </Grid>
                    <Grid container direction="column" justifyContent="center" alignItems="center" style={{ height: height - HEADER_SIZE }}>
                        <Grid container item lg={12}>
                            <Grid item lg={3}></Grid>
                            <Grid item lg={6}>
                                <Paper elevation={3}>
                                    <Box p={5}>
                                        <Typography variant="h5" component="h5">Reset Password</Typography>
                                        <form noValidate autoComplete="off">
                                            <TextField
                                                label="Username"
                                                aria-label="username"
                                                variant="outlined"
                                                margin="normal"
                                                fullWidth
                                                onChange={handleUpdateUser} />
                                            <Box display={forgotSent ? 'flex' : 'none'}><FormHelperText style={{ fontSize: '16px' }}>Reset password email sent...</FormHelperText></Box>
                                            <Box mt={2}>
                                                <Button
                                                    className="mt-25"
                                                    variant="contained"
                                                    color="primary"
                                                    aria-label="send reset email"
                                                    onClick={handleSendResetEmail}
                                                    disabled={disableSubmit}
                                                >Send Reset Email</Button>
                                                <Button className="mt-25 ml-10" color="primary" ml={5} aria-label="cancel" onClick={cancel}>Cancel</Button>
                                            </Box>
                                        </form>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default Forgot;
